<template>
  <div class="loading-state" role="status" aria-busy="true">
    <span class="sr-only"><slot>Loading…</slot></span>
    <div v-for="i in 3" :key="i" class="skeleton" aria-hidden="true" />
  </div>
</template>
